import type { IUploadedFile } from '@/apiClient/types/file'
import type { IFileProcessingStatus } from '@/apiClient/types/fileProcessingStatus'
import { UPLOADED_FILE_IN_PROGRESS_STATUSES } from '@/apiClient/types/fileProcessingStatus'

const IN_PROGRESS = new Set<string>(UPLOADED_FILE_IN_PROGRESS_STATUSES)

export function isUploadedFileStatusInProgress(
  status: IFileProcessingStatus,
): boolean {
  return IN_PROGRESS.has(status)
}

/** The BE deletes the original of a file it redacted card data from, so it can't be downloaded. */
export function isUploadedFileChdRedacted(file: IUploadedFile): boolean {
  return file.status_details?.chd_redacted === true
}
